import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-checklist',
    templateUrl: './checklist.component.html',
    styleUrls: ['./checklist.component.scss'],
    standalone: false
})
export class ChecklistComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
